import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { UserDto } from '@app/generated/model';

import { Observable, Subject, takeUntil } from 'rxjs';
import { getCurrentUser } from '@dwo/selectors';
import { Store } from '@ngrx/store';
import { MsalService } from '@azure/msal-angular';
import { ReleaseNoteService } from '@app/core/services/release-note.service';
import { AppInsightsService } from '@app/core/services/app-insights.service';
import { LoggingService } from '@app/shared/services/logging.service';
import { FeatureFlagService } from '@app/core/services/feature-flag.service';
import { NetworkStatusService } from '@app/core/services/network-status.service';
import { FeatureFlagKey } from '@dwo/enums';
import { TranslateService } from '@ngx-translate/core';
import { ChangeLanguage } from '@dwo/actions';

@Component({
  selector: 'app-user',
  templateUrl: 'user.component.html',
  styleUrls: ['user.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UserComponent implements OnInit {
  public user: UserDto;
  public usersFirstLetter: string;
  public isOpen = false;
  public currentVersion: string = '';
  public language = localStorage.getItem('language') || 'en';
  readonly featureFlagKey = FeatureFlagKey;
  readonly online$: Observable<boolean>;
  private readonly destroy$ = new Subject<boolean>();

  constructor(
    private store: Store,
    private authService: MsalService,
    private releaseNoteService: ReleaseNoteService,
    private appInsightsService: AppInsightsService,
    private log: LoggingService,
    public featureFlags: FeatureFlagService,
    networkStatus: NetworkStatusService,
    private translateService: TranslateService,
  ) {
    this.online$ = networkStatus.isOnline();
  }

  ngOnInit(): void {
    this.store
      .select(getCurrentUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: UserDto) => {
        this.user = user;
        this.usersFirstLetter = this.user?.fullName?.charAt(0);
      });

    // Fetch current version
    this.releaseNoteService
      .checkVersionUpdate()
      .pipe(takeUntil(this.destroy$))
      .subscribe((versionCheck) => {
        this.currentVersion = versionCheck.currentVersion || '';
      });
  }

  setLanguage(language: string): void {
    this.language = language;
    this.translateService.use(language);
    this.store.dispatch(new ChangeLanguage(language));
    localStorage.setItem('language', language);
  }

  clickOnUserInfo(event): void {
    event.stopPropagation();
  }

  signOut(): void {
    this.log.event('Logout', { Reason: 'manual' });
    this.appInsightsService.clearUser();
    this.authService.logout();
  }
}
